import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-header-alarm-simple",
  "use": "app-icon-header-alarm-simple-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-header-alarm-simple\"><g fill-rule=\"nonzero\" fill=\"none\"><path d=\"M11.562 3C7.96 3 5.41 5.828 5.41 9.33v4.82L3 18.097h18l-2.41-3.974V9.376c0-3.5-2.55-6.376-6.153-6.376h-.875z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /><path d=\"M9 19.677C9 20.96 10.343 22 12 22s3-1.04 3-2.323H9z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol